import { Box, Typography } from '@mui/material';
import { IconInfinity, IconSparkles, IconUser } from '@tabler/icons-react';

export default function AnnualUnlimitedCard({
    price,
    comparisonPrice,
    discountPercent,
    selected,
    disabled = false,
    onClick,
}: {
    price: string;
    comparisonPrice?: string;
    discountPercent?: number;
    selected: boolean;
    disabled?: boolean;
    onClick: () => void;
}) {
    return (
        <Box
            component="button"
            type="button"
            aria-pressed={selected}
            disabled={disabled}
            onClick={onClick}
            sx={{
                position: 'relative', isolation: 'isolate', overflow: 'hidden', width: '100%', minHeight: 220,
                display: 'grid', gridTemplateColumns: { xs: '1fr', md: 'minmax(0, 1fr) auto' },
                alignItems: 'end', gap: 2.5, p: { xs: 2.5, sm: 3 }, textAlign: 'left', fontFamily: 'inherit',
                border: '2px solid', borderColor: selected ? 'var(--lm-accent)' : '#6688DB', borderRadius: '12px',
                background: 'radial-gradient(circle at 95% 0%, rgba(54, 118, 255, .34), transparent 42%), linear-gradient(135deg, #111A2B 0%, #17274C 100%)',
                color: '#fff', cursor: disabled ? 'not-allowed' : 'pointer',
                boxShadow: selected ? '0 0 0 3px rgba(0, 68, 255, .12), 0 16px 36px rgba(13, 28, 62, .18)' : '0 10px 28px rgba(13, 28, 62, .14)',
                '&:hover': disabled ? {} : { borderColor: '#91B1FF', boxShadow: '0 0 0 3px rgba(0, 68, 255, .18), 0 18px 40px rgba(13, 28, 62, .24)' },
                '&:focus-visible': { outline: '3px solid var(--lm-accent)', outlineOffset: 3 },
                '&:disabled': { opacity: .65 },
            }}
        >
            <Box sx={{ minWidth: 0, alignSelf: 'stretch', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#A9C3FF' }}>
                    <IconSparkles size={18} stroke={1.7} aria-hidden="true" />
                    <Typography sx={{ fontSize: 12, fontWeight: 800, letterSpacing: '.08em', textTransform: 'uppercase' }}>Максимум возможностей</Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1.25, mt: 1.5 }}>
                    <IconInfinity size={32} stroke={1.9} aria-hidden="true" />
                    <Typography component="h3" sx={{ color: '#fff', fontFamily: '"Inter", system-ui', fontWeight: 900, fontSize: { xs: 25, sm: 30 }, letterSpacing: '-.03em', lineHeight: 1.15 }}>
                        Годовой безлимит
                    </Typography>
                    {selected && <Typography sx={{ px: 1, py: .35, borderRadius: '5px', bgcolor: 'var(--lm-accent)', color: '#fff', fontSize: 12, fontWeight: 800 }}>Выбрано</Typography>}
                </Box>
                <Typography sx={{ color: '#D6E2FA', fontSize: 14, lineHeight: 1.5, mt: 1.25, maxWidth: 540 }}>
                    Все подходящие лиды в вашей категории и географии в течение 365 дней
                </Typography>
                <Box sx={{ display: 'inline-flex', alignItems: 'center', alignSelf: 'flex-start', gap: 1, mt: 2, px: 1.25, py: .75, border: '1px solid rgba(169, 195, 255, .35)', borderRadius: '6px', bgcolor: 'rgba(101, 145, 233, .12)' }}>
                    <IconUser size={18} stroke={1.8} color="#A9C3FF" aria-hidden="true" />
                    <Typography sx={{ color: '#E8F0FF', fontSize: 13, fontWeight: 700 }}>Персональная настройка сервиса</Typography>
                </Box>
            </Box>
            <Box sx={{ minWidth: 0, textAlign: { xs: 'left', md: 'right' }, alignSelf: 'end' }}>
                <Typography sx={{ color: '#A9C3FF', fontSize: 12, fontWeight: 700 }}>Оплата за год</Typography>
                <Typography sx={{ color: '#fff', fontSize: { xs: 30, sm: 36 }, fontWeight: 900, lineHeight: 1.15, whiteSpace: 'nowrap', mt: .4 }}>{price}</Typography>
                {comparisonPrice && <Typography sx={{ color: '#ACBBD4', fontSize: 14, textDecoration: 'line-through', mt: .35 }}>{comparisonPrice}</Typography>}
                {discountPercent && <Typography sx={{ display: 'inline-block', color: '#95E8B7', fontSize: 13, fontWeight: 800, mt: .8 }}>Скидка за год {discountPercent}%</Typography>}
            </Box>
        </Box>
    );
}
